<template>
  <div class="bg-[#111b2d]">
    <div class="aspect-square md:aspect-video">
      <Canvas
        v-if="!state.loading && state.seatplan"
        v-bind="state.seatplan"
        :rules="rules"
        :cart="cart"
        :wheel="wheel"
      />
    </div>
    <aside v-if="legend" class="px-4 md:px-6 transition" :class="[state.loading ? 'opacity-0' : '']">
      <div class="py-4 md:py-6 border-t border-black text-white text-sm">
        <div class="-ml-6 -mt-2 md:flex flex-wrap justify-center">

          <div class="flex items-center pl-6 pt-2">
            <div class="border-[3px] rounded-full relative">
              <div class="p-[2px]">
                <div class="w-6 h-6 icon-check"></div>
              </div>
            </div>
            <span class="pl-2">Ihre Auswahl</span>
          </div>

          <div v-if="hasCategory('pga')" class="flex items-center pl-6 pt-2">
            <div class="p-[5px]">
              <div class="w-6 h-6 rounded-full bg-pga-400"></div>
            </div>
            <span class="pl-2">{{ state.seatplan?.seatplan.categories.pga }}</span>
          </div>

          <div v-if="hasCategory('pgb')" class="flex items-center pl-6 pt-2">
            <div class="p-[5px]">
              <div class="w-6 h-6 rounded-full bg-pgb-400"></div>
            </div>
            <span class="pl-2">{{ state.seatplan?.seatplan.categories.pgb }}</span>
          </div>

          <div v-if="hasCategory('pgc')" class="flex items-center pl-6 pt-2">
            <div class="p-[5px]">
              <div class="w-6 h-6 rounded-full bg-pgc-400"></div>
            </div>
            <div class="pl-2 leading-tight">
              <span>{{ state.seatplan?.seatplan.categories.pgc }}</span>
              <!-- <br><span class="text-xs opacity-50">Eingeschränkte Sicht</span> -->
            </div>
          </div>

          <div v-if="hasCategory('pgd')" class="flex items-center pl-6 pt-2">
            <div class="p-[5px]">
              <div class="w-6 h-6 rounded-full bg-pgd-400"></div>
            </div>
            <div class="pl-2 leading-tight">
              <span>{{ state.seatplan?.seatplan.categories.pgd }}</span>
              <br><span class="text-xs opacity-50">Eingeschränkte Sicht</span>
            </div>
          </div>

          <div class="flex items-center pl-6 pt-2">
            <div class="p-[5px]">
              <div class="w-6 h-6 rounded-full bg-[#293242]"></div>
            </div>
            <span class="pl-2">Belegt</span>
          </div>

          <div class="flex items-center pl-6 pt-2">
            <div class="p-[5px]">
              <div class="w-6 h-6 rounded-full border icon-wheelchair"></div>
            </div>
            <span class="pl-2">Rollstuhl</span>
          </div>

          <div class="flex items-center pl-6 pt-2">
            <div class="p-[5px]">
              <div class="w-6 h-6 rounded-full border icon-unavailable"></div>
            </div>
            <span class="pl-2">Nicht buchbar</span>
          </div>

        </div>
      </div>
    </aside>
  </div>
</template>

<script setup>
import Http from '@/helpers/http';
import { reactive, watch } from 'vue';
import Canvas from './Canvas.vue';

const props = defineProps({
  setup: {
    type: String,
    required: true,
  },
  cart: {
    type: String,
    required: true,
  },
  rules: {
    type: Array,
    default: () => ['preventOrphans', 'consecutive'],
  },
  legend: {
    type: Boolean,
    default: true,
  },
  wheel: {
    type: Boolean,
    default: false,
  },
});

const state = reactive({
  seatplan: null,
  loading: true,
});

async function setup() {
  state.loading = true;
  state.seatplan = await Http.get(props.setup);
  state.loading = false;
}

watch(() => props.setup, setup, {
  immediate: true,
});

function hasCategory(theme) {
  return state.seatplan?.seatplan.categories[theme] !== undefined;
}

defineExpose({
  setup,
});

</script>


<style scoped>

.icon-check,
.icon-unavailable,
.icon-wheelchair {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 32px;
}

.icon-check {
  background-image: url('/media/seatplan/check.png?v=1');
}

.icon-unavailable {
  background-image: url('/media/seatplan/unavailable.png?v=1');
}

.icon-wheelchair {
  background-image: url('/media/seatplan/wheelchair.png?v=1');
}

</style>
